import { z } from "zod";

export default z.object({ "cd": z.string().describe("회사 코드"), "name": z.string().describe("회사 이름"), "targetYn": z.enum(["Y","N"]).describe("적용 대상 여부") }).describe("회사 정보");
